// https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia#Exceptions
export enum DeviceError {
  NotFoundError = "NotFoundError",
  NotAllowedError = "NotAllowedError",
  NotReadableError = "NotReadableError",
}
